import { render, staticRenderFns } from "./FieldSelectorModal.vue?vue&type=template&id=3c647e81"
import script from "./FieldSelectorModal.vue?vue&type=script&lang=js"
export * from "./FieldSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports